import { inject, Injectable } from "@angular/core";

import { AnalyticsService, EVENT_UAEVENT } from "@hermes/hermes-web-fragments-analytics";

const EVENT_CATEGORY_GEO_FILTERING = "GeoBanner";

@Injectable()
export class TrayAnalyticsService {
    private analyticsService = inject(AnalyticsService);

    public sendUserClosingTrayEvent(trayName: string): void {
        if (trayName === "geofiltering-tray") {
            this.analyticsService.sendRawData({
                event: EVENT_UAEVENT,
                eventcategory: EVENT_CATEGORY_GEO_FILTERING,
                eventaction: "Click",
                eventlabel: "Close",
            });
        }
    }
}
